
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReviewDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"review_uid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"review_details"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"review_uid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"review_uid"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scraped_on"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"conseil_chambre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"note_rapport_qp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"note_emplacement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"note_service"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"note_chambre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"note_proprete"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"note_literie"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"note_cuisine"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"note_service_resto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"note_ambiance_resto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"note_confort"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"note_restauration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sollicite"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"point_fort"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commentaire_deta_inter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commentaire_plat_boisson"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commentaire_accessibilite"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commentaire_securite"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commentaire_acti_proxi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commentaire_chambres"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commentaire_vegetarien"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commentaire_restrict_alim"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commentaire_enfants"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commentaire_accessibilite_pmr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commentaire_conseil_parking"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lieu_repas"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type_repas"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prix_repas"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plat_reco"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"place_parking"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"option_statio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sur_mobile"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"platform"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logo2"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":888}};
    doc.loc.source = {"body":"query ReviewDetails($review_uid: String!) {\r\n  review_details(review_uid: $review_uid) {\r\n    scraped_on\r\n    conseil_chambre\r\n    note_rapport_qp\r\n    note_emplacement\r\n    note_service\r\n    note_chambre\r\n    note_proprete\r\n    note_literie\r\n    note_cuisine\r\n    note_service_resto\r\n    note_ambiance_resto\r\n    note_confort\r\n    note_restauration\r\n    sollicite\r\n    point_fort\r\n    commentaire_deta_inter\r\n    commentaire_plat_boisson\r\n    commentaire_accessibilite\r\n    commentaire_securite\r\n    commentaire_acti_proxi\r\n    commentaire_chambres\r\n    commentaire_vegetarien\r\n    commentaire_restrict_alim\r\n    commentaire_enfants\r\n    commentaire_accessibilite_pmr\r\n    commentaire_conseil_parking\r\n    lieu_repas\r\n    type_repas\r\n    prix_repas\r\n    plat_reco\r\n    place_parking\r\n    option_statio\r\n    sur_mobile\r\n    platform {\r\n      name\r\n      logo\r\n      logo2\r\n    }\r\n  }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["ReviewDetails"] = oneQuery(doc, "ReviewDetails");
        
